import { useEffect, useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { http, errText } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { AdminDashboard } from "./AdminDashboard";

const Login = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const { data } = await http.post("/auth/login", { email, password }); onDone(data); }
    catch (x) { setErr(errText(x)); }
    setBusy(false);
  };
  const f = "w-full rounded-full border border-[#D9D1C2] bg-white px-6 py-4 text-sm outline-none focus:border-[#A8613C]";
  return (
    <div className="min-h-screen grid place-items-center bg-[#F4F0E8] px-5">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#FBFBF8] rounded-[28px] p-8 sm:p-10 border border-[#E6E0D4] space-y-4">
        <Logo testId="admin-logo" />
        <h1 className="font-display text-4xl font-light text-[#2D2A26] pt-4">Practice admin</h1>
        <input data-testid="admin-email-input" type="email" required className={f} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-password-input" type="password" required className={f} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        {err && <p data-testid="admin-login-error" className="text-sm text-[#B4442B]">{err}</p>}
        <button data-testid="admin-login-submit-btn" disabled={busy} className="btn-pill w-full justify-center bg-[#2D2A26] text-white hover:bg-[#A8613C] py-4 text-sm">
          {busy && <Loader2 size={16} className="animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);
  useEffect(() => { http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)); }, []);
  if (user === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-[#A8613C]" /></div>;
  if (!user) return <Login onDone={setUser} />;
  const logout = async () => { await http.post("/auth/logout").catch(() => {}); setUser(false); };
  return (
    <div className="min-h-screen bg-[#FBFBF8]">
      <header className="border-b border-[#E6E0D4] px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo testId="admin-logo" />
        <button data-testid="admin-logout-btn" onClick={logout} className="btn-pill border border-[#D9D1C2] px-4 py-2 text-sm text-[#2D2A26] hover:bg-[#F4F0E8]"><LogOut size={14} /> Sign out</button>
      </header>
      <AdminDashboard />
    </div>
  );
}
